module.exports = __webpack_public_path__ + "img/pic_5@2x.80c0ac59.png";